import { ArrowRightIcon, TimerOffIcon } from 'lucide-react';

import { AlertDialog, AlertDialogAction, AlertDialogBody, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/dialog';
import { FeaturedIcon } from '@/components/ui/featured-icon';
import { LoadingSwap } from '@/components/ui/loading-swap';

interface QuizExpirationTimeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSubmit: () => void | Promise<void>;
  isPending?: boolean;
}

export default function QuizExpirationTimeDialog(quizExpirationTimeDialogProps: QuizExpirationTimeDialogProps) {
  const { open, onOpenChange, onSubmit, isPending } = quizExpirationTimeDialogProps;
  return (
    <AlertDialog onOpenChange={onOpenChange} open={open}>
      <AlertDialogContent className={'sm:max-w-96'}>
        <AlertDialogBody>
          <AlertDialogHeader>
            <FeaturedIcon>
              <TimerOffIcon />
            </FeaturedIcon>
            <div className={'flex min-w-0 grow flex-col gap-0.5'}>
              <AlertDialogTitle>Czas na wykonanie upłynął</AlertDialogTitle>
              <AlertDialogDescription className={'text-text-tertiary text-xs'}>Czas na wykonanie upłynął. Nie można już kontynuować wykonanie zadań.</AlertDialogDescription>
            </div>
          </AlertDialogHeader>
        </AlertDialogBody>
        <AlertDialogFooter>
          <AlertDialogAction onClick={onSubmit} disabled={isPending}>
            <LoadingSwap isLoading={isPending ?? false}>Przejdź dalej</LoadingSwap>
            <ArrowRightIcon />
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
